<template>
  <span>
    <a ref="address" @click="generateMailTo" href="#" class="email">{{
      this.address
    }}</a>
  </span>
</template>
<script>
export default {
  props: ["address"],
  computed: {
    reverseAddress() {
      return this.address
        .split("")
        .reverse()
        .join("");
    }
  },
  methods: {
    generateMailTo() {
      this.$refs.address.href = "mailto:" + this.address;
    }
  }
};
</script>
<style lang="scss" scoped>
.email {
  color: inherit;
  text-decoration: none;
  padding-left: 0.2rem;
}
</style>
